import React from 'react';
import PropTypes from 'prop-types';
import MaterialPaper from 'material-ui/Paper';

import { paper, noTopMargin } from './Paper.less';

const Paper = ({ topMargin = true, children, ...other }) => (
  <MaterialPaper className={`${paper} ${topMargin ? '' : noTopMargin}`} children={children} {...other} />
);

Paper.propTypes = {
  topMargin: PropTypes.bool,
  children: PropTypes.node,
};

export default Paper;
